export const DATA_TYPES = [
  { id: "scoreboard", label: "Scoreboard" },
  { id: "player_batting", label: "Player Batting" },
  { id: "player_pitching", label: "Player Pitching" },
  { id: "team_batting", label: "Team Batting" },
  { id: "team_pitching", label: "Team Pitching" },
  { id: "guts", label: "Guts" },
  { id: "park_factors", label: "Park Factors" },
  { id: "expected_runs", label: "Expected Runs" },
  { id: "value", label: "Value" },
  { id: "situational", label: "Situational" },
  { id: "baserunning", label: "Baserunning" },
  { id: "splits", label: "Splits" },
  { id: "battedball", label: "Batted Ball" },
  { id: "rolling", label: "Rolling" },
];

export const DIVISIONS = [
  { label: "Division 1", value: 1 },
  { label: "Division 2", value: 2 },
  { label: "Division 3", value: 3 },
];

export const YEARS = [2025, 2024, 2023, 2022, 2021];

export const DATA_TYPE_CONFIG = {
  scoreboard: {
    hasYears: false,
    hasDate: true,
    hasSearch: false,
    hasConference: false,
    hasDivision: true,
    hasPlayerList: false,
    hasMinPA: false,
    hasMinIP: false,
    hasApplyFilters: false,
    searchPlaceholder: "",
    yearLabel: "",
    multiYear: false,
    dateLabel: "Date:",
  },
  player_batting: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasMinPA: true,
    hasMinIP: false,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    canAddToPlayerList: true,
    yearLabel: "Years to include:",
    multiYear: true,
  },
  player_pitching: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasMinPA: false,
    hasMinIP: true,
    hasApplyFilters: true,
    canAddToPlayerList: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  team_batting: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasMinPA: false,
    hasMinIP: false,
    hasApplyFilters: true,
    searchPlaceholder: "Search teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  team_pitching: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasMinPA: false,
    hasMinIP: false,
    hasApplyFilters: true,
    searchPlaceholder: "Search teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  guts: {
    hasYears: false,
    hasDate: false,
    hasSearch: false,
    hasConference: false,
    hasDivision: false,
    hasMinPA: false,
    hasMinIP: false,
    hasApplyFilters: false,
    searchPlaceholder: "",
    yearLabel: "",
    multiYear: false,
  },
  park_factors: {
    hasYears: false,
    hasDate: false,
    hasSearch: true,
    hasConference: false,
    hasDivision: true,
    hasMinPA: false,
    hasMinIP: false,
    hasApplyFilters: false,
    searchPlaceholder: "Search teams...",
    yearLabel: "",
    multiYear: false,
  },
  expected_runs: {
    hasYears: true,
    hasDate: false,
    hasSearch: false,
    hasConference: false,
    hasDivision: true,
    hasMinPA: false,
    hasMinIP: false,
    hasApplyFilters: false,
    searchPlaceholder: "",
    yearLabel: "Year:",
    multiYear: false,
  },
  value: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasMinPA: true,
    hasMinIP: false,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  situational: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasMinPA: true,
    hasMinIP: false,
    hasPlayerType: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  baserunning: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasMinPA: false,
    hasMinIP: false,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  splits: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasMinPA: true,
    hasMinIP: false,
    hasPlayerType: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  battedball: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasMinPA: true,
    hasMinIP: false,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
  rolling: {
    hasYears: true,
    hasDate: false,
    hasSearch: true,
    hasConference: true,
    hasDivision: true,
    hasPlayerList: true,
    hasMinPA: false,
    hasMinIP: false,
    hasPlayerType: true,
    hasApplyFilters: true,
    searchPlaceholder: "Search players or teams...",
    yearLabel: "Years to include:",
    multiYear: true,
  },
};

export const getDataTypeConfig = (type) => {
  return DATA_TYPE_CONFIG[type] || DATA_TYPE_CONFIG.player_batting;
};
